import breakpoints from '@guestyci/foundation/theme/breakpoints';

/**
 * @typedef {Object} MediaSet
 * @property {string} xs: 0,
 * @property {string} sm: 576,
 * @property {string} md: 768,
 * @property {string} lg: 992,
 * @property {string} xl: 1200,
 * @property {string} xlg: 1900
 * */

type MediaSet = {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
  xlg: string;
};

type MinMax = 'min' | 'max';

/**
 * @param {'min' | 'max'} breakpointDirection used in media query as min-width or max-width
 * @param {number} breakpointValue value of breakpoint
 * @returns {string} media query string
 * */
const getMediaQuery = (
  breakpointDirection: MinMax,
  breakpointValue: number
): string =>
  `@media screen and (${breakpointDirection}-width: ${breakpointValue}px)`;

const mediaSets: Record<MinMax, MediaSet> = (['min', 'max'] as const).reduce(
  (mediaAcc, direction) => {
    mediaAcc[direction] = breakpoints.keys.reduce((acc, key) => {
      acc[key as keyof MediaSet] = getMediaQuery(
        'max',
        (breakpoints.values as Record<keyof MediaSet, number>)[
          key as keyof MediaSet
        ]
      );
      return acc;
    }, {} as MediaSet);
    return mediaAcc;
  },
  {} as Record<MinMax, MediaSet>
);

export default mediaSets;
